/* eslint-disable linebreak-style */
import React, { ReactElement } from 'react';
import ReactDOM from 'react-dom';
// @ts-ignore
const { axios } = window;

interface EditableFieldParams {
    updateUrl: string|null;
    id: string|null;
    attribute:string|null;
    value:string;
}

const EditableField: React.FC <EditableFieldParams> = (props): ReactElement => {
  const {
    updateUrl,
    id,
    attribute,
    value,
  } = props;

  // @ts-ignore
  async function update(event) {
    const newTextValue = event.target.textContent;

    axios.post(updateUrl, {
      id,
      attribute,
      value: newTextValue,
    });
  }

  return (
    <div contentEditable onBlur={(event) => update(event)}>
      {value}
    </div>
  );
};

export default EditableField;

if (document.getElementsByClassName('react-component-editable-field')) {
  document.querySelectorAll('.react-component-editable-field').forEach((element) => {
    const updateUrl = element.getAttribute('data-updateUrl');
    const id = element.getAttribute('data-id');
    const attribute = element.getAttribute('data-attribute');
    const value = String(element.innerHTML);
    ReactDOM.render(
      <EditableField
        updateUrl={updateUrl}
        id={id}
        attribute={attribute}
        value={value}
      />,
      element,
    );
  });
}
